<script lang="ts">
	import type { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel';
	import type { Component, Snippet } from 'svelte';
	import Slider from './Slider.svelte';

	interface Props {
		options?: EmblaOptionsType;
		autoplay?: Record<any, any>;
		wheelGestures?: Record<any, any> | boolean;
		nav?: 'arrows' | 'dots' | 'none';
		prevLabel?: string;
		nextLabel?: string;
		header?: Snippet;
		slides: Snippet<[Component]>;
	}

	const {
		options = {},
		autoplay = undefined,
		wheelGestures = true,
		nav = 'arrows',
		prevLabel = 'Vorige',
		nextLabel = 'Volgende',
		header,
		slides
	}: Props = $props();

	let instance: EmblaCarouselType | undefined = $state();
	let canScrollPrev = $state(false);
	let canScrollNext = $state(false);
	let scrollSnapList: number[] = $state([]);
	let selectedScrollSnap = $state(0);

	let canScroll = $derived(canScrollPrev || canScrollNext);

	function updateState(api: EmblaCarouselType) {
		canScrollPrev = api.canScrollPrev();
		canScrollNext = api.canScrollNext();
		scrollSnapList = api.scrollSnapList();
		selectedScrollSnap = api.selectedScrollSnap();
	}

	function initSlider(e: CustomEvent<EmblaCarouselType>) {
		instance = e.detail;
		updateState(instance);
		instance.on('select', updateState);
		instance.on('resize', updateState);
		instance.on('slidesChanged', updateState);
	}
</script>

{#if header}
	{@render header()}
{/if}

<Slider {options} {autoplay} {wheelGestures} let:Slide on:init={initSlider}>
	{@render slides(Slide)}
</Slider>

{#if nav !== 'none' && canScroll}
	{#if nav === 'arrows'}
		<div class="slider-nav">
			<button
				type="button"
				class="slider-nav-arrow slider-nav-arrow--prev"
				disabled={!canScrollPrev}
				onclick={() => instance?.scrollPrev()}
				aria-label={prevLabel}
			></button>
			<button
				type="button"
				class="slider-nav-arrow slider-nav-arrow--next"
				disabled={!canScrollNext}
				onclick={() => instance?.scrollNext()}
				aria-label={nextLabel}
			></button>
		</div>
	{:else if nav === 'dots'}
		<div class="slider-pagination">
			{#each scrollSnapList as _snap, index (index)}
				<button
					type="button"
					class="slider-bullet"
					class:is-active={index === selectedScrollSnap}
					onclick={() => instance?.scrollTo(index)}
				></button>
			{/each}
		</div>
	{/if}
{/if}
